import React, { Component } from 'react';
import cn from 'classnames';
import styles from './TableOptions.scss';

import Switcher from 'containers/Switcher';
import Checkbox from 'components/common/Checkbox';
import IconTh from 'react-icons/lib/fa/th';
import IconList from 'react-icons/lib/fa/th-list';
import { withTranslation } from 'react-i18next';

class TableOptions extends Component {
  render() {
    const { className, handleList, handleExtended, isTable, isExtended, client, t } = this.props;

    return (
      <div className={cn(styles.TableOptions, className)}>
        <div
          className={styles.Checkbox}
          data-tip={t('components.building.tableOptions.tip')}
          data-for="global"
        >
          { isTable ?
            <Checkbox
              innerStyle={styles.ChessCheckInner}
              text={t('components.building.tableOptions.checkbox')}
              handle={handleExtended}
              checked={isExtended}
              classNameClone="ExtendedChess"
            /> : ''
            }
        </div>
        {
            client ?
              <div className={styles.Switcher}>
                <Switcher
                  defaultChecked={isTable}
                  leftIcon={<IconTh />}
                  rightIcon={<IconList />}
                  elementStyle={'Round'}
                  onClick={handleList}
                />
              </div> : null
          }
      </div>
    );
  }
}

export default withTranslation()(TableOptions);



// WEBPACK FOOTER //
// ./src/components/Building/Chess/TableOptions/TableOptions.js